import { useState } from 'react';
import FormHelperText from '@lingoda/ui/fields/FormHelperText';
import { styled, useTheme } from '@lingoda/ui';
import { CardElement, type StripeCardElement, type StripeCardElementChangeEvent } from '../models';

interface Props {
    onChange?: (event: StripeCardElementChangeEvent) => void;
    onReady?: (el: StripeCardElement) => void;
}

export const CreditCard = ({ onChange, onReady }: Props) => {
    const theme = useTheme();
    const [error, setError] = useState<string>();

    const onCardElementChange = (event: StripeCardElementChangeEvent) => {
        if (event && event.error) {
            setError(event.error.message);
        } else {
            setError(undefined);
        }
        if (onChange) {
            onChange(event);
        }
    };

    const onCardElementReady = (el: StripeCardElement) => {
        if (onReady && el) {
            onReady(el);
        }
    };

    return (
        <>
            <CardElementStyled
                id="lingoda-card"
                options={{
                    style: {
                        base: {
                            // this has to be hardcoded since there is a flickering if you use rems
                            fontSize: '16px',
                            fontFamily: 'Open Sans',
                            fontSmoothing: 'antialiased',
                            color: theme.palette.text.primary,
                            '::placeholder': {
                                color: theme.palette.text.secondary,
                            },
                        },
                    },
                }}
                onChange={onCardElementChange}
                onReady={onCardElementReady}
            />
            <FormHelperText error>{error}</FormHelperText>
        </>
    );
};

const CardElementStyled = styled(CardElement)(({ theme }) => ({
    width: '100%',
    cursor: 'text',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2, 1.75),
    background: theme.palette.common.white,
    border: '1px solid',
    borderColor: theme.colors.border['interactive-subtle'],
    '&:hover': {
        borderColor: theme.colors.border['interactive-subtle-hover'],
    },
    '&.StripeElement--focus': {
        boxShadow: `0 0 0 2px ${theme.palette.primary.main}` /* visually looks like 2px border */,
        borderColor: 'transparent',
    },
}));
